import React from "react";
import wanderLuxe_logo from "../static/images/WL_LOGO.svg";

export const SuccessModal = ({ onClose }) => {
  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        <div className="success-modal-content">
          <p>Thank you for your query.</p>
          <p>We will reach out to you shortly.</p>
        </div>
        <img src={wanderLuxe_logo} alt="WanderLuxe_logo" />

        <div>
          <button style={{ margin: "1rem" }} onClick={onClose} className="button-greyish">
            Close
          </button>
        </div>

      </div>
    </div>
  );
};